<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Destino de depósito docs.
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Finanzas</span>
      <span> /</span>
      <span>Destino de deposito docs.</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <form autocomplete="off" [formGroup]="formHeader">
      <div [ngClass]="{'row filtros-body': true, disabledContent: !enableContent}">
        <!-- <div class="row filtros-body"> -->
        <div class="col" style="max-width: 200px;">
          <div class="md-form">
            <div class="md-form">
              <input placeholder="RUT" class="form-control" type="text" value="" maxLength="10" required #rutDepositante
                formControlName="rut" formatRut />
              <label for="rutDepositante">RUT</label>
              <div *ngIf="
                  formHeader.get('rut').invalid &&
                  (formHeader.get('rut').dirty ||
                  formHeader.get('rut').touched)
                  ">
                <mdb-error *ngIf="formHeader.get('rut').hasError('required')">
                  Ingrese rut
                </mdb-error>
              </div>
            </div>
          </div>
        </div>
        <div class="col" style="max-width: 200px;">
          <div class="md-form">
            <input value="" type="text" class="form-control" placeholder="Nombre del depositante" required #nombre
              formControlName="nombre" />
            <label for="nombre">Nombre</label>
            <div *ngIf="
                  formHeader.get('nombre').invalid &&
                  (formHeader.get('nombre').dirty ||
                  formHeader.get('nombre').touched)
                  ">
              <mdb-error *ngIf="formHeader.get('nombre').hasError('required')">
                Ingrese nombre
              </mdb-error>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <!-- FOOTER -->
  <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
    <div></div>
  </div>
</div>

<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">

    <div class="table-responsive" *ngIf="listaMovimientos">

      <app-no-data-alert *ngIf="listaMovimientos?.length === 0">
      </app-no-data-alert>

      <table class="table table-striped table-hover table-sm align-middle" *ngIf="listaMovimientos?.length > 0">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Banco</th>
            <th scope="col">Nro. Cheque</th>
            <th scope="col">Banco destino</th>
            <th scope="col">Cuenta bancaria</th>
            <th scope="col">Depósito</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let mov of listaMovimientos">
            <td>{{mov.banco_nombre_origen}}</td>
            <td>{{mov.numero_doc}}</td>
            <td>{{mov.additionalData?.nombre_banco_destino}}</td>
            <td>{{mov.numero_cuenta}}</td>
            <td *ngIf="mov.numero_deposito">{{mov.numero_deposito | numerico}}</td>
            <td *ngIf="!mov.numero_deposito">&nbsp;</td>
          </tr>
        </tbody>
      </table>
    </div>


  </div>
</div>

<div class="card mb-2 wow">
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <button mdbBtn type="button" color="default" (click)="back()" mdbWavesEffect>
      REGRESAR
    </button>
    <button mdbBtn type="button" color="info" (click)="showModalAgregarBanco();" mdbWavesEffect
      *ngIf="listaMovimientos?.length > 0">
      AGREGAR BANCO
    </button>
    <button mdbBtn type="button" color="success" (click)="guardarDeposito()" mdbWavesEffect
      *ngIf="listaMovimientos?.length > 0">
      GUARDAR
    </button>

  </div>
</div>

<!-- MODAL Agregar banco -->
<app-destino-deposito-modal-agregar-banco (onSuccess)="onDepositoAgregado($event)">
</app-destino-deposito-modal-agregar-banco>